import { PaymentOrderStatus, PaymentType } from './Payment';

export enum RecurringInitiator {
  CUSTOMER = 'customer',
  MERCHANT = 'merchant',
}

export type RecurringData = {
  orderId: string;
  status: PaymentOrderStatus;
  resignUrl: string;
  verifyUrl: string;
  tokenId?: string;
};

export type CreateRecurringPaymentPayload = {
  email: string;
  offerId: string;
  orderId: string;
  paymentType: PaymentType | null;
};
